// project-imports
import { Box, Collapse, Grid, IconButton, Stack, Typography } from '@mui/material';
import Navigation from './Navigation';
import SimpleBar from '@/components/base-component/third-party/SimpleBar';
import MainCard from '@/components/base-component/MainCard';
import { Logout, Setting2, TextalignJustifycenter, User } from 'iconsax-react';
import Avatar from '@/components/base-component/extended/Avatar';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import useAuth from '@/hooks/useAuth';
import UserDrawer from '@/components/bs-component/card/UserDrawer';
import NavUser from './NavUser';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { user } = useAuth();
  const theme = useTheme();
  return (
    <>
      <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
        <UserDrawer />
        <Navigation />
      </SimpleBar>
      <NavUser />
    </>
  );
}
